import http from './http'

const clienteService = {
  getAll: page => http.get(`/clientes?page=${page}`).then(result => result.data),
  getAllWithoutPagination: () => http.get(`/allclientes`).then(result => result.data),
  getAllAtivos: page => http.get(`/clientes/ativos/?page=${page}`),
  getById: id => http.get(`/clientes/${id}`).then(result => result.data.data),
  getByIdAtivo: id => http.get(`/clientes/ativos/${id}`).then(result => result.data.data),
  getByNome: (str, page) => http.get(`/clientesdescr/${str}?page=${page}`).then(result => result.data),
  getByNomeAtivo: str => http.get(`/clientes/ativos/${str}`).then(result => result.data),
  delete: id => http.delete(`/clientesdelete/${id}`).then(result => result.data.data),
  savePost: data => http({
    method: 'post',
    url: `/clientes`,
    data
  }).then(result => result.data.data),
  savePut: data => http({
    method: 'put',
    url: `/clientes/${data.id}`,
    data
  }).then(result => result.data.data)
}
export default clienteService
